import * as React from 'react';

export function WhiteSpacing() {
    return <div
            style={{
                backgroundColor: "white",
                width: ".2rem",
                height: "45%",
                marginTop: ".5rem",
                marginBottom: ".5rem",
                marginLeft: "1rem",
                marginRight: "1rem",
            }}
        />
}